module.exports = __webpack_public_path__ + "images/xl_guangdong.png?dace8a3dae9be385ed0ec94101b56ac7";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_guangdong.png
// module id = 237
// module chunks = 1